import { Component } from '@angular/core';

@Component({
  template: '<h1>Something bad happened</h1>',
})
export class VoidComponent {
  constructor() {}
}
